module.exports = __webpack_public_path__ + "communication.2L5JKbJr.svg";